import script from "./AppHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./AppHeader.vue?vue&type=script&setup=true&lang=js"

import "./AppHeader.vue?vue&type=style&index=0&id=bf205f6c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bf205f6c"]])

export default __exports__